import { Serializable } from '@admin/core/models/serializable';

export class JobseekerMatchedAnnouncement
  implements Serializable<JobseekerMatchedAnnouncement>
{
  fromObject(obj: any): JobseekerMatchedAnnouncement {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public jobseekerId: number;
  public announcementId: number;
  public announcementTitle: string;
  public announcementMatchingListId: number;
  public lastStatusUpdateDate: Date;
}
